import React, { useRef } from 'react';
var VeltAutocompleteGroupOption = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-group-option", { ref: ref }, children));
};
export default VeltAutocompleteGroupOption;
